<template>
      <section class="common-input" @click="checkplate()">
         
          <section class="pkey-win">
              <!-- <header class="pkey-header">请输入车牌号</header> -->
              <div class="pkey-win-body">
                    <div class="pkey-ipt pkey-foucs" @click.stop="keyshows">
                        <ul>
                            <li :class="['txt',{'active':index==activeIndex}]" @click="changeInput(index)" v-for="(item,index) in carNumList" v-if="index != carNumList.length-1 && index < 2" :key="index">{{item}}</li>
                            <li class="marker"><b></b></li>
                            <li :class="['txt',{'active':index==activeIndex}]" @click="changeInput(index)" v-for="(item,index) in carNumList" v-if="index != carNumList.length-1 && index>1" :key="index">{{item}}</li>
                            <!-- <li :class="['plus',{active:show}]" v-for="(item,index) in carNumList" v-if="index == carNumList.length-1" @click="new_energy()"  :key="index">{{item}}</li> -->
							<li :class="['plus',{'active':index==activeIndex}]" @click="changeInput(index)" v-for="(item,index) in carNumList" v-if="index == carNumList.length-1 && index>1" :key="index">
								<span v-if="item == ''"></span>{{item}}
							</li>
                        </ul>
                    </div>
                    <div class="query" @click.stop="carquery()" >{{btntxt}}</div>
                    <slot name="btn"></slot>
                    <div class="history" v-show="showHistory"  @click.stop="historyquery()">
                        <div class="his_desc"><span>{{carNum.slice(0,2)}}<b></b>{{carNum.slice(2)}}</span></div>
                        <div class="delete_h" @click.stop="deleteHistory()"><img src="../../../static/images/delete.png" alt=""></div>
                    </div>
             </div>
         </section>
        <section class="pkey-keyboard"  @click.stop v-bind:class="{keyboard:showindex}">
             <header class="pkey-header2">
                <label class="pkey-chacelbtn" @touchstart="closewin">重输</label><label class="pkey-okbtn" @touchstart="checkplate()">完成</label>
             </header>

             <section class="pkey-keyscontain">
                <ul>
                     <li v-show="txtboardshow" v-for="(item,index) in cartxt"  :key="index">
                         <span class="check-input" v-show="index==cartxt.length-1" @click.stop @touchstart="txtboardshow=false,numboardshow=true">ABC</span>
                         <label v-for="(items,indexi) in item"  @touchend="touchend2()" v-bind:class="{ bg: items==current }" @touchstart="txtclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                         <span class="delete" v-show="index==cartxt.length-1"  @touchstart="deletes()"></span>
                     </li>
                     <li v-show="numboardshow" v-for="(item,index) in numtxt" :key="index">
                         <span class="check-input" v-show="index==numtxt.length-1" @touchstart="txtboardshow=true,numboardshow=false">字</span>
                        <label v-for="(items,indexi) in item"  @touchend="touchend()" v-bind:class="{ bg: items==current }" @touchstart="numclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                         <span class="delete" v-show="index==numtxt.length-1" @touchstart="deletes()"></span>
                     </li>
                     <li v-show="numboardshow2" v-for="(item,index) in numtxt2" :key="index">
                        <span class="check-input" v-show="index==numtxt2.length-1" @touchstart="txtboardshow=true,numboardshow=false">字</span>
                        <label v-for="(items,indexi) in item"  @touchend="touchend()" v-bind:class="{ bg: items==current }" @touchstart="numclick(items,indexi,item.length)" :key="indexi">{{items}}</label>
                        <span class="delete" v-show="index==numtxt2.length-1" @touchstart="deletes()"></span>
                     </li>
                </ul>
             </section>

        </section>
    </section>
 </template>

   <script>
    import {DETAIL as API} from "@/assets/api";
    // import topNav from "../topnav/topnav";
    export default{
        data(){
            return{
                title:"寻车",
                plate:'',
                keyb:'',
                txtboardshow:true,
                numboardshow:false,
                numboardshow2:false,
                showindex:false,
                mleft:0,
                number:7,
                tips:'',
                carNum:'',
                current:"",
                showHistory:false,
                'show':true,
                activeIndex:null,//当前选中的车牌输入框 
                images:require("../../../static/images/adv.png"),
                cartxt:[
                    ['京','津','渝','沪','冀','晋','辽','吉','黑','苏'],
                    ['浙','皖','闽','赣','鲁','豫','鄂','湘','粤','琼'],
                    ['川','贵','云','陕','甘','青','蒙','桂','宁','新'],
                    ['藏','使','领','警','学','港','澳']
                ],
                numtxt:[
                //   ['1','2','3','4','5','6','7','8','9','0'],
                  ['Q','W','E','R','T','Y','U','I','O','P'],
                  ['A','S','D','F','G','H','J','K','L'],
                  ['Z','X','C','V','B','N','M']
                ],
                numtxt2:[
                    ['1','2','3','4','5','6','7','8','9','0'],
                    ['Q','W','E','R','T','Y','U','P'],
                    ['A','S','D','F','G','H','J','K','L'],
                    ['Z','X','C','V','B','N','M']
                ],
                carNumList:["","","","","","","",""],//
                // lon:"113.903895",//经度
                // lat:"22.582263",//纬度
                lon:"",//经度
                lat:"",//纬度
                mapData:{},
                searchCarNum:null, 
                timeOut:false,//请求地理位置是否超时
            }
        },
        props:{
            btntxt:{
                type:String,
                default:()=>"立即缴费"
            },
        },
        watch: {
            plate: {
                handler(val) {
                    this.$emit('carNumChange', val)
                },
            }
        },
        methods:{
            txtclick(txt,indexi,size){

                this.current=txt;
                if(this.plate.length>this.number && this.activeIndex == null){
                    return
                }
                // this.txtboardshow = false;
                // this.numboardshow = true;
                // this.numboardshow2 = false;

                //let arr = this.plate.split('');
                if(this.activeIndex == 0){
                    this.carNumList.splice(this.activeIndex,1,txt)
                    let item = this.plate.split("");
                    item.splice(this.activeIndex,1,txt)
                    this.plate = item.join("");
                    this.activeIndex = null;
                }else{
                if(this.plate.length <= this.number){
                    this.plate+=txt;
                    let index = this.plate.length-1;
                    //this.carNumList[index] = this.plate.slice(-1);
                    this.carNumList.splice(index,1,this.plate.slice(-1))
                }
                }
                
                //this.carNumList = arr;
                this.keyb = txt;
                this.composition(indexi,size);
                this.changeActiveIndex();
            },
            numclick(num,indexi,size){
                this.current=num;
                if(this.plate.length>this.number && this.activeIndex == null){
                    return
                }
                if(this.plate.length > 0){
                    this.txtboardshow = false;
                    this.numboardshow = false;
                    this.numboardshow2 = true;
                }
                if(this.activeIndex){
                    this.carNumList.splice(this.activeIndex,1,num)
                    // this.plate = this.plate.split("").splice(this.activeIndex,1,num).join("");
                    let item = this.plate.split("");
                    item.splice(this.activeIndex,1,num)
                    this.plate = item.join("");
                    this.activeIndex = null;
                }else{
                if(this.plate.length <= this.number){
                    this.plate+=num;
                    let index = this.plate.length-1;
                    //this.carNumList[index] = this.plate.slice(-1);
                    this.carNumList.splice(index,1,this.plate.slice(-1))
                }
                }
                this.keyb = num;
                this.composition(indexi,size);
                this.changeActiveIndex();
            },
            touchend(){
                this.current=""
            },
            touchend2(){
                this.current="";
                setTimeout(() => {
                    this.txtboardshow = false;
                    this.numboardshow = true;
                    this.numboardshow2 = false; 
                }, 200);
            },
            new_energy(){
            this.number=7;
            this.show=false;
            },
            changeInput(index){//修改选中输入框
            if(this.plate.length < 1){
                index = 0;
            }
            if(index == 0){
				this.txtboardshow = true;
                this.numboardshow = false;
                this.numboardshow2 = false;
			}else if(index == 1){
                this.txtboardshow = false;
                this.numboardshow = true;
                this.numboardshow2 = false;
            }else{
                this.txtboardshow = false;
                this.numboardshow = false;
                this.numboardshow2 = true;
            }
            this.activeIndex = index;
            },
            deletes(){
                this.activeIndex = null;
                let index = this.plate.length-1;
                this.$set(this.carNumList, index, "");
                this.plate=this.plate.substr(0, this.plate.length-1)
                if(this.plate.length == 0){
                    this.txtboardshow = true;
                    this.numboardshow = false;
                    this.numboardshow2 = false;
                }
                if(this.plate.length == 1){
                    this.txtboardshow = false;
                    this.numboardshow = true;
                    this.numboardshow2 = false;
                }
                this.activeIndex = this.plate.length;
            },
            composition(indexi,length){
                //闪烁位置设置
                let winwidth = document.documentElement.clientWidth;
                let keyW = winwidth * 65 / 750;
                let kkongW = winwidth * 9 / 750;
                let showW = winwidth * 120 / 750;
                let size = length;
                let isEven = (size%2==0) ? true : false;
                if(indexi<size/2){ // 左边
                    let mleft = 0;
                    if(isEven){ // 偶数
                        let n = size/2-(indexi+1) + 0.5;
                        mleft = n*(keyW + kkongW) + showW/2;
                    }
                    else{ // 奇数
                        let n = (size/2+0.5)-(indexi+1);
                        mleft = n*(keyW + kkongW) + showW/2;
                    }
                    mleft = (mleft > winwidth/2) ? winwidth/2 : mleft;
                    this.mleft = -mleft;
                }else{ // 右边
                    let mright = 0;
                    if(isEven){
                        let n = (indexi+1) - size/2 -0.5;
                        mright = n*(keyW + kkongW) - showW/2;
                    }else{
                        let n = (indexi+1) - (size/2+0.5);
                        mright = n*(keyW + kkongW) - showW/2;
                    }
                    mright = (mright > (winwidth/2-showW)) ? (winwidth/2-showW) : mright;
                    this.mleft = mright;
                }
                //闪烁
                this.keyshow = true;
                let self = this;
                setTimeout(function(){
                    self.keyshow = false;
                },2250);

            },
            checkplate(){
                this.showindex = false;
                this.activeIndex = null;
            },
            closewin(){
                this.$emit('transferclose',false);
                this.plate='';
                this.carNumList=["","","","","","","",""]
                this.txtboardshow = true;
                this.numboardshow = false;
                this.numboardshow2 = false;
                this.activeIndex = 0;
            },
            keyshows(){
                this.showindex=true;
                return false;
            },
            carquery(){//查找车辆
                let carNum=this.plate;
                if(this.commonUtil.isEmpty(carNum)){
                    this.$toast({
                        duration:1200,
                        message: '请输入车牌号'
                    });
                    return;
                }
                else{
                    if(!(/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[警京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{0,1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}[A-Z0-9]{0,1}[A-Z0-9]{0,1}$/.test(carNum))){
                        //不是车牌
                        this.$toast({
                        duration:1200,
                        message: '车牌号格式不正确'
                        });
                        return;
                    }
                    else{//格式正确
                        this.commonUtil.setCookie("carNum",carNum,30);
                        this.$emit("commitCarNum",carNum);
                    }
                    // this.$emit('transferplate',this.plate);
                }
            },
            historyquery(){//查询历史记录中的车辆信息
                let carNum=this.carNum
                let arr = carNum.split("");
                if(carNum&&carNum.length<8){
                    arr.push("");
                }
                this.carNumList = arr;
                this.plate = carNum;


                // let originalId = sessionStorage.getItem("originalId");
                // if(originalId){
                //     //this.getCarDetail()
                //     if(this.commonUtil.getDeviceType() == "ios"){//苹果
                //         this.getLocationBD();
                //     }else{//安卓
                //         this.getLocationMsg();
                //     }
                // }
            },
            deleteHistory(){
                this.commonUtil.delCookie("carNum2");
                this.showHistory=false;
            },
            getHistoryCarNum(){//获取历史车牌记录
                let originalId = sessionStorage.getItem("originalId");
                // let originalId="o0b1TwS4YYKnaqay_Adx8xoqxHxo";
                let url=this.btntxt=='领取优惠券'?API.GET_CARNUM_HISTORY:API.SEARCH_CARNUM_HISTORY
                if(originalId){
                    
                    var req = {'originalId':originalId}
                    this.$http({
                        method: 'post',
                        url: url,
                        data: req,
                        // data: params,
                        success: function(data){
                            if(data.code == 0){
                                data = data.data;
                                if(data.length > 0){
                                    //let carNum = data.vehicleno;
                                    let carNum = data[0];
                                    if(carNum){
                                        this.commonUtil.setCookie("carNum2",carNum,30)
                                        if(!this.commonUtil.isEmpty(carNum)){
                                            this.showHistory=true;
                                            this.carNum=carNum;
                                        } 
                                    }
                                }
                            }
                        }.bind(this),
                        error: function(error){
                            console.log(error);
                        }
                    })
                }
            },
            getLocationStr(){//通过百度api获取省份简称
                if(this.$store.state.locationObj){
                    let cityStr = this.$store.state.locationObj.str
                    if(cityStr){
                        if(this.carNumList.length>0 && this.carNumList[0] ==""){
                            this.carNumList.splice(0,1,cityStr);
                            this.plate = cityStr+this.plate.slice(1);
                        }
                    }
                    return;
                }
                if(this.$store.state.onlyMark == 1){
                    return;
                }else{
                    this.$store.state.onlyMark = 1;
                }
                if(!sessionStorage.getItem("originalId")){
                    return;
                }
                var geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition((r)=>{
                    this.$store.state.onlyMark = 0;//禁止重复调用的标识
                    if(!r){//用户决绝地理位置授权	//.accuracy
                        // this.$dialog.alert({
                        //     title: '提示',
                        //     message: "未获取当前地理位置信息，无法查询车辆位置信息"
                        // })   
                        return;	
                    }	
                    let address = r.address;
                    let city = address.city;//所在城市
                    let province = address.province;//所在省份
                    let str = this.commonUtil.provinceForShort(city)?this.commonUtil.provinceForShort(city):this.commonUtil.provinceForShort(province);
                    let obj={
                        lat:r.point.lat,
                        lng:r.point.lng,
                        str,
                    }
                    this.$store.state.locationObj = obj;
                    if(str){
                        if(this.carNumList.length>0 && this.carNumList[0] ==""){
                            this.carNumList.splice(0,1,str);
                            this.plate = str+this.plate.slice(1);
                        }
                    }
                },{enableHighAccuracy: true})
            },
            changeActiveIndex(){//更改选中位置
                for(let i=0;i<this.carNumList.length;i++){
                    if(this.carNumList[i] == ""){
                        this.activeIndex = i;
                        break;
                    }
                }
            },
            closeKeyBoard(){//
                this.showindex = false;
            },
            showHistoryCarNum(){
                let carNum=this.commonUtil.getCookie("carNum2");
                if(!this.commonUtil.isEmpty(carNum)&&this.btntxt!=='领取优惠券'){
                    this.showHistory=true;
                    this.carNum=carNum;
                }else{
                    this.getHistoryCarNum();
                }
            },
        },
        created(){
            this.showHistoryCarNum()
        },
        mounted(){
            //this.getLocationStr();
            let dom = document.getElementById("app");
            dom.removeEventListener("click",this.closeKeyBoard);
            dom.addEventListener("click",this.closeKeyBoard);
        }
       
    }
 </script>
<style>
.common-input{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  width: 100%;
  background-color: #F8F8F8;
}
 .common-input .pkey-keyscontain li label.bg{
   background: #c3c3c3;
 }
 .common-input .pkey-keyscontain li label{
    display: inline-block;
    width: 8.4%;
    background: white;
    margin: 2px 2px;
    padding: 12px 0px;
    border-radius: 5px;
 }
 .common-input .pkey-keyscontain{
    background: #D1D5DA;
    padding: 5px 0;
 }
 .pkey-keyboard{
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 2;
    display: none
 }
 .common-input .pkey-header{
     font-size: 14px;
     padding:20px 0;
 }
 .common-input .pkey-header2{
    height: 35px;
    line-height: 35px;
    background: #F4F4F6;
 }
 .common-input .pkey-chacelbtn{
    width: 45%;
    display: inline-block;
    text-align: left;
 }
 .common-input .pkey-okbtn{
    width: 45%;
    display: inline-block;
    text-align: right;
 }
 .common-input .check-input{
     display: inline-block;
    padding: 12px 0;
    /* float: left; */
    position: absolute;
    left: 12px;
    top: 2px;
    background: #ABB3BA;
    border-radius: 5px;
    width: 40px;
 }
 .common-input .pkey-keyscontain li{
   position: relative;
 }
 .common-input .delete{
    width: 40px;
    display: inline-block;
    position: absolute;
    background-color: #ABB3BA;
    right: 12px;
    top: 4px;
    height: 37px;
    border-radius: 5px;
    background-image: url('../../../static/images/backDeleteImg.jpg');
    background-size: 74%;
    background-position: center center;
    background-repeat: no-repeat;
 }
.common-input .pkey-ipt li{
   width: 10%;
   display: block;
    background-color: #fff;
    border: 1Px solid #a2c4fb;
    border-radius: 0.15rem;
    /* width: 1.8rem; */
    margin: 0 auto;
    height: 2rem;
    line-height: 2rem;
    border-radius: 5px;
    font-size: 0.9rem;
    text-align: center;
    border: 1Px solid rgb(154,154,154);
 }
.common-input .pkey-ipt li:first-child{
    /* border-color: rgb(70,135,248);   */
    font-weight: bold;
 }
.common-input .pkey-win-body{
    border-top:1px solid #fff;
    border-bottom:1px solid #fff;
 }
.common-input .pkey-ipt li.txt{
    /* border-color: rgb(70,135,248); */
 }
.common-input .pkey-ipt li.plus{
    border-color: #39BD49;;
    border-style: dashed;
 }
.common-input .pkey-ipt li.marker{
     border:none;
     width: 3%;
 }
.common-input .pkey-ipt li.marker b{
     display:block;
     width:4px;
     height:4px;
     border-radius: 3px;
     margin: 0 auto;
     margin-top: 14px;
     background: rgb(70,135,248);
 }
.common-input .pkey-ipt li.active{
     background: #ddd;
      border-color: rgb(70,135,248);
  }
.common-input .pkey-ipt ul {
    width: 92%;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 14px auto;
}
 /* .pkey-ipt ul li.active {
    border: 2px solid #478FF1;
} */
.common-input .pkey-ipt li.plus span{
	display: block;
	height: 2rem;
    line-height: 2rem;
	background: url("../../../static/images/xinnengyuan.png") no-repeat center;
 	background-size: 90%;
}
.common-input .active{
  background: url("../../../static/images/xinnengyuan.png") no-repeat center;
  background-size: 90%;
}
.common-input .keyboard{
  display: block;
}
.common-input .query {
    width: 92%;
    text-align: center;
    height: 2.4rem;
    line-height: 2.4rem;
    background-color: rgb(70,135,248);
    color: white;
    margin: 1.2rem auto;
    border-radius: 3px;
    font-size: 0.9rem;
    /* -moz-box-shadow: 0.1rem 0.1rem 0.7rem #A3A3A3;
    -webkit-box-shadow: 0.1rem 0.1rem 0.7rem #A3A3A3;
    box-shadow: 0rem 0.2em 0.8rem #5b82c18a; */
}
.common-input .history {
    border: 1Px dashed rgb(69,133,245);
    width: 92%;
    height: 39px;
    margin: 15px auto;
    border-radius: 5px;
    line-height: 39px;
    display: flex;
}
.common-input .his_desc {
    margin: 0 auto;
    width: 50%;
    text-align: center;
}
.common-input .his_desc{
    margin: 0 auto;
    width: 50%;
    text-align: center;
}
.common-input .his_desc span b{
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 3px;
    margin-top: 13px;
    background: rgb(70,135,248);
    margin: 0 5px 3px 5px;
}
.common-input .history img{
    width: 80%;
}
.common-input .delete_h{
    width: 23px;
    padding-top: 4px;
    padding-right: 15px;
    position: absolute;
    right: 15px;
}
.common-input .ad{
    width: 92%;
    display: block;
    margin: 0 auto;
}
.common-input .ad img{
    width: 100%;
}
.common-input .common-input{
    margin-top:0;
  background-color: white;
  border-bottom: 1px solid #fff;
  padding: 0;
}
 </style>




// WEBPACK FOOTER //
// src/components/common/commonInput.vue